import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { QRCodeModule } from 'angularx-qrcode';
import { StationStatusComponent } from './component/station-status.component';
import { CommonTranslationModule } from '@sdbn/common';

@NgModule({
  declarations: [
    StationStatusComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    QRCodeModule,
    CommonTranslationModule
  ]
})
export class StationStatusModule { }
